import { Button } from 'antd';
import React, { useContext } from 'react';
import { ReactComponent as ExpandIcon } from '@/assets/images/icons/expand-icon.svg';
import PropTypes from 'prop-types';
import { ApiDocumentContext } from '@/contexts/ApiDocumentContext';
import { uniqueId } from 'lodash';

function ApiResponses({ data }) {
  const { setOpenDrawer, setDrawerTitle, setResData } =
    useContext(ApiDocumentContext);

  const renderPopupTitle = (statusCode, itemData) => {
    const desc =
      statusCode === '200'
        ? itemData?.description || 'OK'
        : itemData?.description;
    return (
      <>
        <div className="drawer-title">Response</div>
        <div
          className={`http-status ${
            statusCode === '200' ? '--stt-ok' : '--stt-error'
          }`}
        >
          <div>
            <span className="code">{statusCode}</span>
            <span className="desc">{desc}</span>
          </div>
        </div>
      </>
    );
  };

  const handleOnClickExpand = (statusCode, itemData) => {
    setOpenDrawer(true);
    setDrawerTitle(renderPopupTitle(statusCode, itemData));
    setResData(itemData);
  };

  const renderItem = (statusCode, itemData) => {
    const desc =
      statusCode === '200'
        ? itemData?.description || 'OK'
        : itemData?.description;
    return (
      <>
        <div
          className={`http-status ${
            statusCode === '200' ? '--stt-ok' : '--stt-error'
          }`}
        >
          <div>
            <span className="code">{statusCode}</span>
            <span className="desc">{desc}</span>
          </div>
        </div>
        <div className="expand-icon">
          <Button
            type="link"
            icon={<ExpandIcon />}
            onClick={() => handleOnClickExpand(statusCode, itemData)}
          />
        </div>
      </>
    );
  };

  return (
    <div className="items">
      {Object.keys(data).length > 0 &&
        Object.keys(data).map((statusCode) => (
          <div className="item" key={uniqueId()}>
            {renderItem(statusCode, data[`${statusCode}`])}
          </div>
        ))}
    </div>
  );
}

ApiResponses.propTypes = {
  data: PropTypes.object,
};

export default ApiResponses;
